// Equipment Data Types
export const FETCH_EQUIPMENT_DATA = '@@fetch_Equipment_Data';
export const FETCH_EQUIPMENT_DATA_SUCCESS = '@@fetch_Equipment_Data_Success';
export const FETCH_EQUIPMENT_DATA_FAILURE = '@@fetch_Equipment_Data_Failure';

// Consumables Data Types
export const FETCH_CONSUMABLES_DATA = '@@fetch_Consumables_Data';
export const FETCH_CONSUMABLES_DATA_SUCCESS = '@@fetch_Consumables_Data_Success';
export const FETCH_CONSUMABLES_DATA_FAILURE = '@@fetch_Consumables_Data_Failure';

// QC Inspection Personnel Data Types
export const FETCH_QC_INSPECTION_PERSONNEL_DATA = '@@fetch_QC_Inspection_Personnel_Data';
export const FETCH_QC_INSPECTION_PERSONNEL_DATA_SUCCESS = '@@fetch_QC_Inspection_Personnel_Data_Success';
export const FETCH_QC_INSPECTION_PERSONNEL_DATA_FAILURE = '@@fetch_QC_Inspection_Personnel_Data_Failure';

// Refresh Actions
export const REFRESH_EQUIPMENT_DATA = '@@refresh_Equipment_Data';
export const REFRESH_CONSUMABLES_DATA = '@@refresh_Consumables_Data';
export const REFRESH_QC_INSPECTION_PERSONNEL_DATA = '@@refresh_QC_Inspection_Personnel_Data';

// Miscellaneous registry (project-level list)
export const FETCH_REGISTRY_MISCELLANEOUS_DATA = '@@fetch_Registry_Miscellaneous_Data';
export const FETCH_REGISTRY_MISCELLANEOUS_DATA_SUCCESS = '@@fetch_Registry_Miscellaneous_Data_Success';
export const FETCH_REGISTRY_MISCELLANEOUS_DATA_FAILURE = '@@fetch_Registry_Miscellaneous_Data_Failure';
export const REFRESH_REGISTRY_MISCELLANEOUS_DATA = '@@refresh_Registry_Miscellaneous_Data';

